import React from 'react';
import '../App.css';
import './HeroSection.css';
import Button from 'react-bootstrap/Button';

function HeroSection() {
  return (
    <div className='hero-container'>
      <video src='/videos/video-1.mp4' autoPlay loop muted />
      <h1 style={{ fontFamily: "Georgia, serif" }}>Professional Carpentry</h1>
      <p className="lead font-weight-normal" style={{ fontFamily: "Georgia, serif" }}>Carpentry, new construction, and renewals services in the Chicagoland area</p>
      <div className='hero-btns'>
        <Button variant="dark" size="lg"  href="/contact">
          GET ESTIMATE
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
